import script from "./LoadingComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingComponent.vue?vue&type=script&setup=true&lang=js"

import "./LoadingComponent.vue?vue&type=style&index=0&id=069bd9a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-069bd9a8"]])

export default __exports__